import { useSelector } from 'react-redux'
import { type QuickMdState } from '@/app/store'

export const useAppSelector = useSelector.withTypes<QuickMdState>()
